import React, { useState } from "react";
import { hasPermission, getContrastYIQ } from "../../../utils";
import moment from "moment";

import { MenuComportamento } from "../../../components/Menus";
import Avatar from "../../../components/Avatar";
import { Badge, Button, UncontrolledTooltip, Dropdown, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const createColumns = ({
  edit,
  printThis,
  isToPrint,
  isConversao,
  setComentariosOportunidade,
  onOpenChatModal,
  onOpenCopilot,
  onCriarCard,
  onVerCards,
  onVerOportunidade,
  hasPipeline = false,
  onChangeStatusInList,
}) => {
  let copy = getColumns(isConversao, setComentariosOportunidade, onChangeStatusInList, onVerOportunidade);

  if (edit) {
    if (copy[0].dataField !== "acoes") {
      copy.unshift({
        dataField: "acoes",
        formatter: (cell, row) => (
          <AcoesFormatter
            row={row}
            edit={edit}
            printThis={printThis}
            onOpenChatModal={onOpenChatModal}
            onOpenCopilot={onOpenCopilot}
            onCriarCard={onCriarCard}
            onVerCards={onVerCards}
            hasPipeline={hasPipeline}
          />
        ),
        csvExport: false,
        headerStyle: { width: "80px" },
        style: { width: "80px", paddingRight: "0px" },
      });
    }
  }
  if (isToPrint) {
    const telefones = copy.find((item) => item.dataField === "telefones");
    const email = copy.find((item) => item.dataField === "cliente.email");
    if (!email) {
      copy = insert(copy, 2, {
        dataField: "cliente.email",
        text: "Email",
        align: "center",
        headerAlign: "center",
        csvExport: true,
      });
    }
    if (!telefones) {
      copy = insert(copy, 2, {
        dataField: "telefones",
        text: "Telefones",
        align: "center",
        headerAlign: "center",
        csvExport: true,
        csvFormatter: (cell, row) => telefonesFormaterCsv(cell, row),
        formatter: (row, column) => telefonesFormaterCsv(row, column),
      });
    }
  }
  return copy;
};

const getColumns = (isConversao, setComentariosOportunidade, onChangeStatusInList, onVerOportunidade) => {
  const columns = [
    isConversao ? getColumnDataEncerramento() : getColumnDataAgendamento(),

    {
      dataField: "cliente.nome",
      text: "Cliente",
      sort: true,
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
        maxWidth: "180px",
      },
      formatter: (cellContent) => (
        <span title={cellContent}>{cellContent}</span>
      ),
    },
    {
      dataField: "anuncio.nome",
      text: "Anúncio",
      sort: true,
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer",
        maxWidth: "160px",
      },
      formatter: (cellContent) => (
        <span title={cellContent}>{cellContent}</span>
      ),
    },
    // {
    //   dataField: 'anuncio.nome',
    //   text: 'Anúncio',
    //   formatter: (row, column) => anuncioFormater(row, column),
    //   csvFormatter: (cell, row) => anuncioFormatterCsv(cell, row),
    //   sort: true
    // },

    {
      dataField: "_meta_.total_comentarios",
      text: "Comentários",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "48px", textAlign: "center" },
      style: { width: "48px", textAlign: "center" },
      csvType: Number,
      headerFormatter: contacatacaoHeader,
      formatter: (cell, row) =>
        contactacaoFormatter(cell, row, setComentariosOportunidade),
    },

    // {
    //   dataField: 'conversas',
    //   text: 'Conversas',
    //   title: 'Conversas',
    //   align: 'center',
    //   headerAlign: 'center',
    //   formatter: (conversas, column) => {
    //     return <p>{conversas.length > 0 ? "Tem conversa" : "Não tem conversa"}</p>;
    //   },
    // },
    {
      dataField: "estagio.nome",
      text: "Estágio",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "120px" },
      style: { width: "120px", textAlign: "center" },
      formatter: (row, column) => estagioFormatter(row, column),
      csvFormatter: (cell, row) => estagioFormatterCsv(cell, row),
      sort: true,
    },

    {
      dataField: "expectativa.nome",
      text: "Expectativa",
      formatter: (row, column) => expectativaFormatter(row, column),
      csvFormatter: (cell, row) => expectativaFormatterCsv(cell, row),
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "110px" },
      style: { width: "110px", textAlign: "center" },
      sort: true,
    },
    {
      dataField: "motivo_encerramento_id",
      text: "Situação",
      formatter: (row, column) => situacaoFormater(row, column, onChangeStatusInList),
      csvFormatter: (cell, row) => situacaoFormatterCsv(cell, row),
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "100px" },
      style: { width: "100px", textAlign: "center" },
      sort: true,
    },

    {
      dataField: "__meta__.valor",
      text: "Valor",
      title: "Valor",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "110px" },
      style: { width: "110px", textAlign: "center" },
      // sort: true,
      formatter: (row, column) => valorFormatter(row, column),
      csvFormatter: (row, column) => valorFormatter(row, column),
      headerFormatter: valorHeader,
    },
    hasPermission("ver-todas-oportunidades") ? getColumnColaborador() : {},
    getColumnDataCadastro(),
  ];

  return columns;
};

const AcoesFormatter = ({ row, edit, printThis, onOpenChatModal, onOpenCopilot, onCriarCard, onVerCards, hasPipeline = false }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      {dropdownOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1040,
          }}
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen(false);
          }}
        />
      )}

      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggleDropdown}
        onClick={(e) => e.stopPropagation()}
        style={{ position: "relative", zIndex: dropdownOpen ? 1041 : "auto" }}
      >
        <DropdownToggle
          tag="span"
          style={{ padding: "0.5rem", background: "transparent", border: "none", cursor: "pointer" }}
        >
          <i className="fas fa-ellipsis-v" style={{ color: "#0847d6" }}></i>
        </DropdownToggle>
        <DropdownMenu strategy="fixed" positionFixed={true}>
          <DropdownItem
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              edit(row.id);
              setDropdownOpen(false);
            }}
          >
            <i className="fas fa-eye mr-2" />
            Ver oportunidade
          </DropdownItem>
          {hasPipeline && (
            <DropdownItem
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onCriarCard && onCriarCard(row);
                setDropdownOpen(false);
              }}
            >
              <i className="fas fa-columns mr-2" />
              Criar card no pipeline
            </DropdownItem>
          )}
          {hasPipeline && (
            <DropdownItem
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onVerCards && onVerCards(row);
                setDropdownOpen(false);
              }}
            >
              <i className="fas fa-list mr-2" />
              Ver cards vinculados
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>

      <button
        onClick={(e) => { e.stopPropagation(); onOpenChatModal && onOpenChatModal(row); }}
        title="Abrir WhatsApp"
        style={{ background: "transparent", border: "none", cursor: "pointer", padding: "2px", display: "flex", alignItems: "center" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32" fill="currentColor">
          <path fill="#25D366" d="M16 .395C7.162.395.011 7.546.011 16.384c0 2.887.756 5.678 2.194 8.145L.01 32l7.686-2.164a15.924 15.924 0 0 0 8.305 2.272h.001c8.838 0 15.989-7.151 15.989-15.989 0-8.838-7.151-15.989-15.989-15.989zm0 29.224a13.2 13.2 0 0 1-6.736-1.848l-.484-.287-4.56 1.284 1.308-4.445-.315-.456a13.198 13.198 0 0 1-2.022-7.249c0-7.314 5.95-13.264 13.265-13.264 3.547 0 6.877 1.381 9.384 3.889 2.508 2.507 3.89 5.837 3.89 9.385 0 7.314-5.95 13.264-13.265 13.264zm7.264-9.949c-.396-.198-2.343-1.156-2.707-1.287-.364-.133-.629-.198-.895.198-.266.396-1.028 1.287-1.26 1.553-.232.264-.463.297-.86.099-.396-.198-1.67-.615-3.182-1.961-1.176-1.05-1.97-2.344-2.202-2.74-.231-.396-.025-.609.173-.807.178-.177.396-.463.595-.694.198-.231.264-.396.396-.662.132-.265.066-.497-.033-.695-.099-.198-.895-2.156-1.228-2.951-.323-.776-.651-.67-.895-.682-.231-.012-.496-.015-.761-.015s-.694.099-1.06.497c-.364.396-1.39 1.356-1.39 3.308s1.423 3.842 1.623 4.106c.198.265 2.799 4.27 6.787 5.98.949.41 1.689.653 2.265.835.951.302 1.819.259 2.505.157.764-.115 2.343-.958 2.674-1.881.33-.923.33-1.713.232-1.88-.099-.165-.364-.264-.76-.462z" />
        </svg>
      </button>

      <button
        onClick={(e) => { e.stopPropagation(); onOpenCopilot && onOpenCopilot(row); }}
        title="Copiloto Insights"
        style={{ background: "transparent", border: "none", cursor: "pointer", padding: "2px", display: "flex", alignItems: "center" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 36 36" fill="none">
          <defs>
            <linearGradient id="sparkleGradList" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor="#11CDEF" />
              <stop offset="100%" stopColor="#11CDEF" />
            </linearGradient>
          </defs>
          <path d="M13 0C13 0 13 8 7.5 10.5C2 13 0 13 0 13C0 13 8 13 10.5 18.5C13 24 13 26 13 26C13 26 13 18 18.5 15.5C24 13 26 13 26 13C26 13 18 13 15.5 7.5C13 2 13 0 13 0Z" fill="url(#sparkleGradList)" />
          <path d="M28 18C28 18 28 21.5 25.5 22.5C23 23.5 22 23 22 23C22 23 25.5 23 26.5 25.5C27.5 28 28 29 28 29C28 29 28 25.5 30.5 24.5C33 23.5 34 23 34 23C34 23 30.5 23 29.5 20.5C28.5 18 28 18 28 18Z" fill="url(#sparkleGradList)" />
        </svg>
      </button>
    </div>
  );
};

const valorFormatter = (cell, row) => {
  return (
    <>
      {Number(row.valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })}
    </>
  );
};

const contactacaoFormatter = (cell, row, setComentariosOportunidade) => {
  return setComentariosOportunidade ? (
    <>
      <a
        href="#"
        onClick={() => comentarioAction(row, setComentariosOportunidade)}
      >
        {row.__meta__.total_comentarios || 0}
      </a>
    </>
  ) : (
    <>{row.__meta__.total_comentarios || 0}</>
  );
};

function comentarioAction(oportunidade, setComentariosOportunidade) {
  setComentariosOportunidade(oportunidade);
}

function contacatacaoHeader(column) {
  return (
    <>
      <div id={`column-${column.text}`}>
        <i className="far fa-comment" style={{ fontSize: "1rem" }} />
      </div>
      <UncontrolledTooltip target={`column-${column.text}`} placement="top">
        Comentários
      </UncontrolledTooltip>
    </>
  );
}

function colaboradorHeader() {
  return (
    <>
      <div id="column-colaborador">
        <i className="far fa-user" style={{ fontSize: "1rem" }} />
      </div>
      <UncontrolledTooltip target="column-colaborador" placement="top">
        Colaborador
      </UncontrolledTooltip>
    </>
  );
}

function valorHeader(column) {
  return (
    <>
      <div id={`column-${column.text}`}>{column.text}</div>
      <UncontrolledTooltip target={`column-${column.text}`} placement="top">
        Valor do(s) produto(s) desta oportunidade
      </UncontrolledTooltip>
    </>
  );
}

function getColumnColaborador() {
  return {
    dataField: "user.name",
    text: "Colaborador",
    formatter: (row, column) => colaboradorFormatter(row, column),
    csvFormatter: (cell, row) => colaboradorFormatterCsv(cell, row),
    headerFormatter: colaboradorHeader,
    align: "center",
    headerAlign: "center",
    headerStyle: { width: "50px", textAlign: "center" },
    style: { width: "50px", textAlign: "center" },
    sort: true,
  };
}

function getColumnDataAgendamento() {
  return {
    dataField: "data_agendamento",
    text: "Data de Agendamento",
    formatter: (row, column) => dataAgendamento(row, column),
    csvFormatter: (cell, row) => dataAgendamentoCsv(cell, row),
    headerStyle: { width: "145px" },
    style: { width: "145px", whiteSpace: "nowrap" },
    csvType: Date,
    sort: true,
  };
}
function getColumnDataCadastro() {
  return {
    dataField: "created_at",
    text: "Data de Cadastro",
    formatter: (row, column) => dataCadastro(row, column),
    csvFormatter: (cell, row) => dataCadastro(cell, row),
    headerStyle: { width: "130px" },
    style: { width: "130px", whiteSpace: "nowrap" },
    csvType: Date,
    sort: true,
  };
}

function getColumnDataEncerramento() {
  return {
    dataField: "data_conversao",
    text: "Data de Conversão",
    formatter: (row, column) => dataEncerramento(row, column),
    csvFormatter: (cell, row) => dataEncerramento(cell, row),
    headerStyle: { width: "130px" },
    style: { width: "130px", whiteSpace: "nowrap" },
    csvType: Date,
    sort: true,
  };
}

const colaboradorFormatter = (cell, row) => (
  <>
    {row.user && (
      <Avatar
        title={row.user.name}
        user={row.user}
        className="avatar-xs"
        style={{
          cursor: "default",
        }}
      />
    )}
  </>
);

const dataAgendamento = (cell, row) => {
  if (!row.data_agendamento) {
    return;
  }
  const dataAgendamento = moment(row.data_agendamento);
  const diff = row.data_encerramento || row.data_conversao
    ? 100
    : dataAgendamento.diff(moment(), "minutes");
  const timeLimit = 30;

  return (
    <>
      <span id={`agendamento-${row.id}`}>
        {diff <= timeLimit && (
          <span className="text-warning mr-1">
            <i className="fas fa-exclamation-circle"></i>
          </span>
        )}
        {dataAgendamento.format("D MMM YYYY HH:mm")}
      </span>
      {diff <= timeLimit && (
        <UncontrolledTooltip target={`agendamento-${row.id}`} placement="top">
          {diff < 0
            ? `Atrasada ${dataAgendamento.fromNow(false)}`
            : `Restam menos de ${diff} minutos para o atendimento`}
        </UncontrolledTooltip>
      )}
    </>
  );
};

const dataEncerramento = (cell, row) => {
  if (!row.data_conversao) {
    return;
  }
  const dataConversao = moment(row.data_conversao);
  return dataConversao.format("D MMM YYYY HH:mm");
};

const dataCadastro = (cell, row) => {
  const dataCadastro = moment(row.created_at);
  return dataCadastro.format("D MMM YYYY HH:mm");
};

const situacaoFormater = (cell, row, onChangeStatusInList) => {
  const isPerdida = !!row.data_encerramento;
  const isConvertida = !!row.data_conversao;

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle tag="span" data-toggle="dropdown" style={{ cursor: "pointer" }}>
          <Badge
            id={`denc-${row.id}`}
            color={isPerdida ? "danger" : isConvertida ? "success" : "info"}
            className="badge-lg"
            pill
          >
            {isPerdida ? "Perdida " : isConvertida ? "Convertida " : "Aberta "}
            {onChangeStatusInList && <i className="fas fa-caret-down"></i>}
          </Badge>
        </DropdownToggle>
        {onChangeStatusInList && (
          <DropdownMenu strategy="fixed" positionFixed={true}>
            {(isPerdida || isConvertida) && (
              <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChangeStatusInList(row, 'Aberta'); }}>Aberta</DropdownItem>
            )}
            {!isConvertida && (
              <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChangeStatusInList(row, 'Convertida'); }}>Convertida</DropdownItem>
            )}
            {!isPerdida && (
              <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChangeStatusInList(row, 'Perdida'); }}>Perdida</DropdownItem>
            )}
          </DropdownMenu>
        )}
      </UncontrolledDropdown>
      {row?.motivoEncerramento && (
        <UncontrolledTooltip target={`denc-${row.id}`} placement="top">
          {row.motivoEncerramento.nome}
        </UncontrolledTooltip>
      )}
    </>
  );
};

const expectativaFormatter = (cell, row) => (
  <Badge color="primary" className="badge-lg" pill>
    {row.expectativa.nome.toLowerCase() === "alta" && (
      <i className="fas fa-fire mr-2"></i>
    )}
    {row.expectativa.nome}
  </Badge>
);

const estagioFormatter = (cell, row) => (
  <>
    <Badge
      pill
      id={`est-${row.id}`}
      //color={row.estagio.cor}
      color={row.cor_estagio.includes("#") ? "secondary" : row.cor_estagio}
      style={
        row.cor_estagio.includes("#")
          ? {
              backgroundColor: row.cor_estagio,
              color: getContrastYIQ(row.cor_estagio),
            }
          : {}
      }
      className="badge-lg"
    >
      {row?.motivoEncerramento && !row?.data_encerramento && (
        <i className="far fa-bookmark mr-2"></i>
      )}
      {row.estagio.nome}
    </Badge>
    {row?.motivoEncerramento && (
      <UncontrolledTooltip target={`est-${row.id}`} placement="top">
        {row.motivoEncerramento.nome}
      </UncontrolledTooltip>
    )}
  </>
);

const anuncioFormater = (cell, row) => (
  <div title={row.anuncio.campanha.nome}>{row.anuncio.nome}</div>
);

const anuncioFormatterCsv = (cell, row) => row.anuncio.nome;

const estagioFormatterCsv = (cell, row) => row.estagio.nome;

const expectativaFormatterCsv = (cell, row) => row.expectativa.nome;

const situacaoFormatterCsv = (cell, row) =>
  row.motivo_encerramento_id ? "Encerrado" : "Aberto";

const colaboradorFormatterCsv = (cell, row) =>
  row.user_id ? row.user.name : "";

const dataAgendamentoCsv = (cell, row) => {
  if (!row.data_agendamento) {
    return "";
  }
  const dataAgendamento = moment(row.data_agendamento);
  return dataAgendamento.format("D/MM/YYYY HH:mm");
};

const dataCadastroCsv = (cell, row) => {
  const dataAgendamento = moment(row.data_agendamento);
  return dataAgendamento.format("D/MM/YYYY HH:mm");
};

const telefonesFormaterCsv = (cell, row) =>
  row?.cliente?.telefones.map((item) => ` (${item.ddd}) ${item.numero}`).join();

const telefonesFormater = (cell, row, showTelefones) => {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        showTelefones(row.cliente_id);
      }}
    >
      {row.__meta__?.total_telefones}
    </a>
  );
};

const insert = (arr, index, newItem) => [
  // part of the array before the specified index
  ...arr.slice(0, index),
  // inserted item
  newItem,
  // part of the array after the specified index
  ...arr.slice(index),
];
